<script setup lang="ts">
import CalculatorScreen from './screens/CalculatorScreen.vue';
</script>

<template>
  <CalculatorScreen />
</template>
